// src/components/forms/AnnouncementForm/ui/AnnouncementDetailsForm.jsx
import React from "react";
import { t } from "i18next";

import TextInputV from "../../elements/TextInputV/TextInputV";
import ImageSelector from "../../elements/ImageSelector/ui/ImageSelector";
import OpenModalButton from "../../elements/OpenModalButton/ui/OpenModalButton";
import TagInput from "../../elements/TagInput/TagInput";

import DropdownUnit from "../../../common/components/DropdownUnit"; // This component remains unchanged
import { units } from "../../adform/constants/units"; // Import units from constants

import Loading from "../../../common/components/Loading";

function AnnouncementDetailsForm({
    announcementData,
    handleImagesChange,
    videoLink,
    handleVideoLinkChange,
    announcementName,
    handleAnnouncementInputChange,
    isSubmitted,
    customTags,
    handleCustomTagsChange,
    handleAddTag,
    handleRemoveTag,
    tagsArray,
    handleSelectCategory,
    description,
    handleDescriptionChange,
    priceType,
    setPriceType,
    price,
    setPrice,
    isLoading,
    onPublish,
    onPreview,
    volumeUnit, // This prop is the unit value (e.g., 'kilogram', 'piece', 'ton', 'liter')
    handleVolumeChange, // This function expects the unit value
}) {

    return (
        <div className="main_form">
            <h2 className="form_heading">{t('announcement')}</h2>
            <div className="title_section">
                <ImageSelector
                    onImagesChange={handleImagesChange}
                    initialImages={announcementData?.image_urls || []}
                />
                <hr className="divider" />
                <div className="video_link_section">
                    <TextInputV
                        isRequired={false}
                        value={videoLink}
                        onInputChange={handleVideoLinkChange}
                        labelText={t('video_link')}
                    />
                </div>
            </div>

            <div className="title_section">
                <TextInputV
                    isRequired={true}
                    value={announcementName}
                    onInputChange={handleAnnouncementInputChange}
                    isSubmitted={isSubmitted}
                    errorText={t('enter_announcement_name')}
                    labelText={t('announcement_name')}
                    placeholder={t('enter_announcement_name')}
                />
            </div>
            <div className="title_section">
                <TagInput
                    value={customTags}
                    onChange={handleCustomTagsChange}
                    onAddTag={handleAddTag}
                    onRemoveTag={handleRemoveTag}
                    tags={tagsArray}
                    isSubmitted={isSubmitted}
                />
            </div>
            <div className="title_section">
                <label className="input_label">{t('select_category')}</label>
                <OpenModalButton 
                    type="category" 
                    onSelect={handleSelectCategory}
                    selectedCategoryId={announcementData?.category_id}
                    selectedSubcategoryId={announcementData?.subcategory_id}
                />
            </div>
            <div className="title_section">
                <TextInputV
                    isRequired={true}
                    value={description}
                    onInputChange={handleDescriptionChange}
                    isSubmitted={isSubmitted}
                    errorText={t('enter_description')}
                    labelText={t('description')}
                    multiline={true}
                    rows={5}
                    placeholder={t('enter_description')}
                />
            </div>

            <div className="title_section">
                <label className="input_label">{t('price')}</label>
                <div className="price_inputs">
                    <button
                        className={priceType === "fixed" ? "price_button active" : "price_button"}
                        onClick={() => setPriceType("fixed")}
                    >
                        {t('fixed_price')}
                    </button>
                    <button
                        className={priceType === "negotiable" ? "price_button active" : "price_button"}
                        onClick={() => setPriceType("negotiable")}
                    >
                        {t('negotiable')}
                    </button>
                </div>
                <div className="price_section_form">
                    <input
                        type="number"
                        className="input_field"
                        placeholder={t('enter_price')}
                        value={price && price !== 'None' && price !== 'null' ? price : ''}
                        onChange={(e) => setPrice(e.target.value)}
                    />
                    <DropdownUnit
                        text={t('volume_production')}
                        options={units} // Pass only the string keys (e.g., 'kg', 'g')
                        selected={volumeUnit} // `volumeUnit` from the hook will be the key
                        onOptionSelect={handleVolumeChange} // `handleVolumeChange` expects the key
                        style={{ width: "200px" }}
                    />
                </div>
            </div>

            <div className="title_section publish_section mobile_hide">
                <button
                    className="ad_form_buttons publish_button"
                    onClick={onPublish}
                    disabled={isLoading}
                >
                    {isLoading ? <Loading /> : t('publish')}
                </button>
                <button
                    className="ad_form_buttons review_button"
                    disabled={isLoading}
                    onClick={onPreview}
                >
                    {t('preview')}
                </button>
            </div>
        </div>
    );
}

export default AnnouncementDetailsForm;